/**
 * Per-type `ABOUT` / `BEST FOR` copy for the widget detail panel (CT-5188) and
 * the builder's live preview (CT-5199) — built once here so the same type reads
 * identically on both surfaces.
 *
 * The strings themselves live in i18n; this map only says **which types have
 * copy at all**. Six of the eighteen catalog types (`donut`, `funnel`, `board`,
 * `feed`, `alerts`, `stat_row`) have none in the prototype, and that is not an
 * oversight to paper over: a type without copy renders neither heading rather
 * than an empty section. Add the type here once the copy exists.
 */
const WIDGET_TYPE_COPY_KEYS = Object.freeze({
  kpi: 'kpi',
  chart: 'chart',
  gauge: 'gauge',
  table: 'table',
  list: 'list',
  map: 'map',
  heat_map: 'heatMap',
  ai_summary: 'aiSummary',
  cost_kpi: 'costKpi',
  usage_heatmap: 'usageHeatmap',
  spend_breakdown: 'spendBreakdown',
  composite_stat: 'compositeStat',
});

/**
 * i18n keys for a widget type, or `null` when the type has no authored copy.
 *
 * @param {string} type Catalog widget type (snake_case).
 * @returns {{ about: string, bestFor: string } | null}
 */
export function widgetTypeCopyKeys(type) {
  const key = WIDGET_TYPE_COPY_KEYS[type];
  if (!key) return null;
  return {
    about: `widgetLibrary.typeCopy.${key}.about`,
    bestFor: `widgetLibrary.typeCopy.${key}.bestFor`,
  };
}

export default WIDGET_TYPE_COPY_KEYS;
